export const translations = {
  zh: {
    home: {
      title: '全球在线会议',
      h264Warning:
        '检测到您的浏览器/设备不支持发送 H.264 视频编码，加入通话后对方可能无法看到您的画面（仍可正常通话语音）。建议使用最新版桌面 Chrome 或 Edge 浏览器重试。',
      yourNameLabel: '你的名字',
      namePlaceholder: '例如：陈伟',
      roomIdLabel: '房间号（留空以创建新会议）',
      roomIdPlaceholder: '例如：AB12CD',
      titleLabel: '会议标题',
      titlePlaceholder: '例如：周会 / 项目评审',
      loginRequiredNotice: '创建会议需要先登录，或输入房间号以访客身份加入。',
      nameRequiredError: '请输入姓名以继续',
      loginRequiredError: '请先登录后再创建会议，或输入房间号加入已有会议',
      createAndJoin: '创建并加入会议',
      joinCall: '加入会议',
      login: '登录',
      logout: '退出',
      adminPanel: '管理后台',
      myMeetings: '我的会议记录',
      adminBadge: '(管理员)',
    },
    call: {
      leave: '离开',
      room: '房间',
      status: {
        CONNECTED: '已连接',
        CONNECTING: '连接中…',
        RECONNECTING: '重新连接中…',
        DISCONNECTED: '已断开',
      },
      enterNameTitle: '输入姓名以加入',
      namePlaceholder: '你的姓名',
      join: '加入',
      connectingOverlay: '正在连接跨境专线…',
      autoplayBlocked: '浏览器已阻止自动播放，点击此处开启画面/声音',
      savingRecord: '正在保存会议记录…',
      recordSavedWithPdf: '会议记录已保存，纪要已下载',
      recordSavedNoPdf: '会议记录已保存（无语音内容，未生成摘要）',
      recordSaveFailed: '会议记录保存失败',
      inactivityWarning: '会议已超过4分钟无人发言，将在1分钟后自动结束（发言即可继续会议）',
      autoEnded: '会议因长时间无人发言已自动结束',
      packetLoss: '检测到丢包 — 正在通过跨境专线重新路由…',
      connectionRestored: '连接已恢复',
      copyLinkSuccess: '邀请链接已复制',
      copyLinkError: '复制失败，请手动复制链接：',
      mute: '静音',
      unmute: '取消静音',
      startVideo: '开启视频',
      stopVideo: '停止视频',
      share: '共享',
      invite: '邀请',
      blur: '虚化',
      captions: '字幕',
      captionPanel: '字幕记录',
      captionsFeature: '字幕翻译',
      endMeeting: '结束会议',
      endMeetingConfirmTitle: '结束会议并保存纪要？',
      endMeetingConfirmDesc: '将向所有参会人结束本次会议，生成AI会议纪要并把PDF邮件发送到您的邮箱。如果您只想自己离开（会议继续），请点击"仅离开"。',
      endMeetingConfirmBtn: '结束并保存',
      leaveOnlyBtn: '仅离开',
      cancelBtn: '取消',
      captionHistoryTitle: (n) => `字幕记录 (${n})`,
      noCaptions: '暂无字幕记录',
      closeCaptionPanel: '关闭字幕记录',
      ariaToggleMic: '切换麦克风',
      ariaToggleCamera: '切换摄像头',
      ariaToggleShare: '切换屏幕共享',
      ariaToggleBlur: '切换背景虚化',
      ariaToggleCaptions: '切换实时字幕',
      ariaToggleCaptionPanel: '切换字幕记录面板',
      ariaToggleCaptionsFeature: '开启/关闭字幕翻译（仅主持人可控制）',
      ariaCopyLink: '复制邀请链接',
      ariaLeave: '离开会议',
      participantsTitle: (n) => `参会人 (${n})`,
      you: ' (你)',
      closeParticipants: '关闭参会人列表',
      cameraOff: '摄像头已关闭',
    },
  },
  en: {
    home: {
      title: 'Global Online Meeting',
      h264Warning:
        'Your browser/device does not support sending H.264 video. Others may not see your video after joining (audio will still work). We recommend the latest desktop Chrome or Edge.',
      yourNameLabel: 'Your name',
      namePlaceholder: 'e.g. Wei Chen',
      roomIdLabel: 'Room ID (leave blank to create one)',
      roomIdPlaceholder: 'e.g. AB12CD',
      titleLabel: 'Meeting title',
      titlePlaceholder: 'e.g. Weekly sync / Project review',
      loginRequiredNotice: 'Log in to create a meeting, or enter a Room ID to join as a guest.',
      nameRequiredError: 'Enter your name to continue',
      loginRequiredError: 'Please log in first to create a meeting, or enter a Room ID to join an existing one',
      createAndJoin: 'Create & join meeting',
      joinCall: 'Join call',
      login: 'Log in',
      logout: 'Log out',
      adminPanel: 'Admin panel',
      myMeetings: 'My meetings',
      adminBadge: '(Admin)',
    },
    call: {
      leave: 'Leave',
      room: 'Room',
      status: {
        CONNECTED: 'Connected',
        CONNECTING: 'Connecting…',
        RECONNECTING: 'Reconnecting…',
        DISCONNECTED: 'Disconnected',
      },
      enterNameTitle: 'Enter your name to join',
      namePlaceholder: 'Your name',
      join: 'Join',
      connectingOverlay: 'Connecting to cross-border relay…',
      autoplayBlocked: 'Browser blocked autoplay, tap here to enable video/audio',
      savingRecord: 'Saving meeting record…',
      recordSavedWithPdf: 'Meeting saved, summary downloaded',
      recordSavedNoPdf: 'Meeting saved (no speech detected, no summary generated)',
      recordSaveFailed: 'Failed to save meeting record',
      inactivityWarning: 'No one has spoken for 4 minutes — the meeting will end in 1 minute unless someone speaks',
      autoEnded: 'Meeting ended automatically due to prolonged silence',
      packetLoss: 'Packet loss detected — rerouting through cross-border relay…',
      connectionRestored: 'Connection restored',
      copyLinkSuccess: 'Invite link copied',
      copyLinkError: 'Could not copy link — copy it manually: ',
      mute: 'Mute',
      unmute: 'Unmute',
      startVideo: 'Start video',
      stopVideo: 'Stop video',
      share: 'Share',
      invite: 'Invite',
      blur: 'Blur',
      captions: 'Captions',
      captionPanel: 'Captions log',
      captionsFeature: 'Captions & Translation',
      endMeeting: 'End meeting',
      endMeetingConfirmTitle: 'End meeting and save minutes?',
      endMeetingConfirmDesc: 'This will end the meeting for everyone, generate an AI summary and email the PDF to you. If you just want to leave while the meeting continues, tap "Leave only".',
      endMeetingConfirmBtn: 'End & save',
      leaveOnlyBtn: 'Leave only',
      cancelBtn: 'Cancel',
      captionHistoryTitle: (n) => `Captions log (${n})`,
      noCaptions: 'No captions yet',
      closeCaptionPanel: 'Close captions log',
      ariaToggleMic: 'Toggle microphone',
      ariaToggleCamera: 'Toggle camera',
      ariaToggleShare: 'Toggle screen share',
      ariaToggleBlur: 'Toggle background blur',
      ariaToggleCaptions: 'Toggle live captions',
      ariaToggleCaptionPanel: 'Toggle captions log panel',
      ariaToggleCaptionsFeature: 'Turn captions & translation on/off (host only)',
      ariaCopyLink: 'Copy invite link',
      ariaLeave: 'Leave call',
      participantsTitle: (n) => `Participants (${n})`,
      you: ' (You)',
      closeParticipants: 'Close participants',
      cameraOff: 'Camera is off',
    },
  },
};
